import { useTranslation } from 'react-i18next'

import { ICON_COLOR, ICON_HEIGHT_16, IconWithTooltip } from '../../../Icon'
import Text from '../../../Text'
import {
  QA_NAME_PHOTO_COVER_BADGE,
  QA_NAME_PHOTO_REORDER,
} from '../RentalPortalPhotoGallery.constants'

import * as styles from './RentalPortalPhotoGalleryTileOverlayFooter.module.css'

import DragIcon from '../../../../icons/drag-and-drop.svg'

function RentalPortalPhotoGalleryTileOverlayFooter({
  hasReorder,
  isCover,
  isReorderDisabled,
  reorderDisabledReason,
}) {
  const { t } = useTranslation()

  return (
    <div className={styles.RentalPortalPhotoGalleryTileOverlayFooter}>
      {isCover ? (
        <Text className={styles.coverBadge} qaName={QA_NAME_PHOTO_COVER_BADGE}>
          {t('RentalPortal.ListingPhotoCoverBadgeKey')}
        </Text>
      ) : null}
      {hasReorder ? (
        <IconWithTooltip
          Icon={DragIcon}
          className={styles.dragIcon}
          color={
            isReorderDisabled ? ICON_COLOR.TextDisabledColor : ICON_COLOR.White
          }
          qaName={QA_NAME_PHOTO_REORDER}
          size={ICON_HEIGHT_16}
          tooltip={
            isReorderDisabled
              ? reorderDisabledReason
              : t('RentalPortal.ListingPhotoReorderKey')
          }
        />
      ) : null}
    </div>
  )
}

export default RentalPortalPhotoGalleryTileOverlayFooter
